import React, { type ReactElement, useMemo } from 'react'
import { type HeaderLink, Role } from 'common/utils/types'
import Layout from 'common/navigation/layout'
import { ReactComponent as AppLogo } from 'assets/appLogo.svg'

import { useAppSelector } from '../../store/hooks'

const headerLinks: HeaderLink[] = [
  // TODO uncomment when implemented
  // {
  //   label: 'Dashboard',
  //   route: 'dashboard',
  //   roles: [UserRoles.Admin],
  //   nestedRoutes: undefined,
  // },
  {
    label: 'Vendori',
    route: 'lista',
    roles: [Role.admin],
    nestedRoutes: undefined,
  },
  {
    label: 'Zahtevi za verifikaciju',
    route: 'zahtevi',
    roles: [Role.admin],
    nestedRoutes: undefined,
  },
  {
    label: 'Moj profil',
    route: 'profil',
    roles: [Role.vendor, Role.consultant],
    nestedRoutes: undefined,
  },
  {
    label: 'Svi tenderi',
    route: 'tenderi',
    roles: [Role.vendor],
    nestedRoutes: undefined,
  },
  {
    label: 'Moje ponude',
    route: 'ponude',
    roles: [Role.vendor],
    nestedRoutes: undefined,
  },
]
const AppLayout: React.FC = (): ReactElement => {
  const { vendor } = useAppSelector((state) => state.vendor)
  const { userInfo } = useAppSelector((state) => state.auth)

  const links = useMemo<HeaderLink[]>(() => {
    if (!userInfo) {
      return []
    }
    return userInfo?.role === Role.admin || vendor?.status === 'verified'
      ? headerLinks
      : headerLinks.filter((l) => l.route === 'profil')
  }, [vendor])

  return <Layout logo={<AppLogo />} links={links} />
}
export default AppLayout
